
import axios from "axios";
import store from "@/store/store";
import Vue from "vue";
import moment from "moment";

export const appStatus = {
  logged: true,
};
export const notify = Vue.prototype.$vs.notify;
export const $loading = Vue.prototype.$vs.loading;
export const $load = (e, is = true) => {
  if (!document.querySelector(e)) return;

  let closeDOM = `${e} > .con-vs-loading`;

  if (is) {
    document.querySelectorAll(e).forEach((dom) => {
      $loading({
        container: dom,
        scale: 0.6,
      });
    });
  } else {
    document.querySelectorAll(e).forEach((dom) => {
      let theDOM = dom.querySelector(".con-vs-loading");
      if (theDOM) $loading.close(dom);
    });
  }
};
export const APIURL = process.env.VUE_APP_API;
export const BASEURL = process.env.VUE_APP_BASE;

export const permissionFail = (type) => {
  let { isSuper, isAdmin, isAuth } = store.getters;
  let error = !isAuth;
  if (type === 1 && !isAdmin) error = true;
  if (type === 2 && !isSuper) error = true;
  console.log("errroorororor", error);
  if (error) {
    notify({
      title: "Error",
      text: `You dont have permission to do that!`,
      color: "danger",
      iconPack: "feather",
      icon: "icon-alert-circle",
      position: "bottom-right",
    });
  }

  return error;
};
export const permissionFailNew = (type) => {
  let { isSuper, isAdmin, isAuth } = store.getters;
  let error = !isAuth;
  if (type === 1 && !isAdmin) error = true;
  if (type === 2 && !isSuper) error = true;
  //   console.log("errroorororor", error);

  return error;
};
export const showPermissionError = (error) => {
  if (error) {
    notify({
      title: "Error",
      text: `You dont have permission to do that!`,
      color: "danger",
      iconPack: "feather",
      icon: "icon-alert-circle",
      position: "bottom-right",
    });
  }
};

export const findById = (arr, id) => arr.find((x) => x.id === id);

export const setProp = (obj, props, value) => {
  const prop = props.shift();
  if (!obj[prop]) {
    Vue.set(obj, prop, {});
  }
  if (!props.length) {
    if (value && typeof value === "object" && !Array.isArray(value)) {
      obj[prop] = { ...obj[prop], ...value };
    } else {
      obj[prop] = value;
    }
    return;
  }
  setProp(obj[prop], props, value);
};

export const deleteProp = (obj, props) => {
  const prop = props.shift();
  if (!obj[prop]) {
    return;
  }
  if (!props.length) {
    Vue.delete(obj, prop);
    return;
  }
  deleteProp(obj[prop], props);
};

const FULL_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const SHORT_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const getDate = (t) => {
  let dateObj = new Date(t);

  let date = dateObj.getDate();

  let month = dateObj.getMonth();
  month = SHORT_MONTHS[month];

  let year = (dateObj.getFullYear() + "").split("");
  year = `${year[2]}${year[3]}`;

  return `${month} ${date} / ${year}`;
};
export const getTime = (t) => {
  let dateObj = new Date(t);

  let timeState = "am";
  let h = dateObj.getHours();
  let m = dateObj.getMinutes();

  if (h > 12) {
    timeState = "pm";
    h = h - 12;
  }
  if (h < 10) {
    h = "0" + h;
  }

  if (m < 10) m = "0" + m;

  return `${h}:${m}${timeState}`;
};

export const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log("Query variable %s not found", variable);
};

function commarize(min) {

  min = min || 1e4;
  // Alter numbers larger than 1k
  if (this >= min) {
    var units = ["k", "M", "B", "T"];

    var order = Math.floor(Math.log(this) / Math.log(1000));

    var unitname = units[order - 1];
    var num = Math.floor(this / 1000 ** order);

    // output number remainder + unitname
    return num + unitname;
  }

  // return formatted original number
  return this.toLocaleString();
}

// Add method to prototype. this allows you to use this function on numbers and strings directly
Number.prototype.commarize = commarize;
String.prototype.commarize = commarize;


export const $api = axios.create({
  baseURL: APIURL,
  timeout: 15000,
});

export const saveAuth = (jwt = false, user, store) => {

  if (jwt) {
    setCookie("__rl", jwt);
    $api.defaults.headers["Authorization"] = `Bearer ${jwt}`;
    store.commit("SETAUTH", user);
  } else {
    // localStorage.jwt = ''
    setCookie("__rl", "");
    store.commit("SETAUTH", {});
    $api.defaults.headers["Authorization"] = ``;
  }
};

export const clearAuth = (store) => {
  // localStorage.clear()
  setCookie("__rl", "");
  if (store) store.commit("SETAUTH", {});
  $api.defaults.headers["Authorization"] = ``;
};


export const getInitial = (str = "Resoil", second = "") => {
  let names = [str];
  if (str.trim().includes(" ")) names = str.split(" ");
  else if (second) names.push(second);
  let initial = "";
  names.forEach((x, xI) => {
    if (xI < 2) initial += x[0];
  });
  return initial.toUpperCase();
};

export const validateEmail = (email) => {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const formatDate = (date) => {
  if (typeof date === "string" || typeof date === "number")
    date = String(new Date(date)).split(" ");
  // return `${date[1]}/${date[2]}/${date[3]}`;
  return `${date[1]}/${date[2]}/${date[3]}`;
};

export function formatPrice(price) {
  price = parseFloat(parseFloat(price).toFixed(2));
  return (
    "$" +
    price.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

export const checkAlphaNum = (str) => {
  return str.match(/^[-\w\s]+$/);
  // return str.replace(/[^a-z0-9]/gi,'')
};

export const formatMonthDate = (date) => {
  return moment(date).utc().format("MMMM/DD/YYYY")
}


export const log = (e, f = false, color = 'blue') => {
  if (f) console.log("%c Log =>", "color:" + color, f)
}




export const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const setCookie = (cname, cvalue, exdays = "21") => {
  let cook = cname + "=" + cvalue;
  if (!location.href.includes("localhost"))
    cook += `; domain=resoilsolutions.com`;

  document.cookie = cook + "; path=/";
};


export const checkCookie = (cookie) => {
  var cookie = getCookie(cookie);
  return user != "";
};

export const arrToObj = (arr, options = {}) => {

  let { key = "id", sort = false } = options;
  let obj = {};

  if (sort && arr[0].hasOwnProperty(sort)) {
    arr = arr.sort((a, b) => (a[sort] > b[sort] ? 1 : -1));
  }
  arr.forEach((x) => {
    if (x[key]) obj[x[key]] = x;
  });

  return obj;
};

// Middlewares

export const initialAuth = (to, store) => {
  return new Promise(async (resolve, reject) => {
    if (store.getters.isAuth) return resolve(true);


    let jwt = getCookie("__rl") || "";

    if (!jwt) return resolve(false);



    $api.defaults.headers["Authorization"] = `Bearer ${jwt}`;


    $api.interceptors.request.use((request) => {
      return request;
      (error) => {
        return Promise.reject(error);
      };
    });

    $api.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response && error.response.status === 403) {
          notify({
            title: "Error",
            text: `You dont have permission to do that!`,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right",
          });
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          notify({
            title: "Error",
            text: error.response.data.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right",
          });
        } else {
          notify({
            title: "Error",
            text:
              (error.response && error.response.data) ||
              "An error occurred. Please try again at a later time.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right",
          });
        }
        return Promise.reject(error);
      }
    );

    $api
      .get("/users/me")
      .then(({ data: user }) => {
        store.commit("SETAUTH", user);
        resolve(true);
      })
      .catch((err) => {
        console.log("ERRRORRROROOROROROROROROR");
        clearAuth(store);
        resolve(false);
      });
  });
};

